import { render, staticRenderFns } from "./otp.vue?vue&type=template&id=d58ad3c6&scoped=true&"
import script from "./otp.vue?vue&type=script&lang=js&"
export * from "./otp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58ad3c6",
  null
  
)

export default component.exports